export default "__VITE_ASSET__DVnc5OBR__"